// función que permite poner evento onScroll debounced y cuando el scroll se para
// ver ejemplo en ecVirtualList
export function onScrollDebouncer(onScrollCallback = () => {}, onScrollStopCallback = () => {}) {
  const onScroll = _onScrollFactory(),
    onStopScroll = _onStopScrollFactory();
  return event => {
    onScroll(event);
    onStopScroll(event);
  };

  /////////////////////////////////////////////////

  function _onScrollFactory() {
    let lastKnownPosition = 0,
      isRefreshPending = false;
    return function onScroll(event) {
      lastKnownPosition = event.target.scrollTop;
      _requestRefresh(event);
    };

    function _onScrollDebounced(event) {
      onScrollCallback(event);
      isRefreshPending = false;
    }

    function _requestRefresh(event) {
      if (!isRefreshPending) {
        requestAnimationFrame(() => _onScrollDebounced(event));
      }
      isRefreshPending = true;
    }
  }

  function _onStopScrollFactory() {
    let whileScrolling;
    return function onStopScroll(event) {
      window.clearTimeout(whileScrolling);
      whileScrolling = setTimeout(() => onScrollStopCallback(event), 400);
    };
  }
}
